import React from 'react';
//import Conexion from './../conexion/conexion';
import Header from '../elementos/basicos/Header';
import Cabecera from '../elementos/basicos/Cabecera';
import Footer from '../elementos/basicos/Footer';
import styled, { StyleSheetManager } from 'styled-components';
import ContactoSepe from './../img/contacto-tus-cursos-sepe.png';
import RedesContacto from '../elementos/basicos/RedesContacto';

//Este objeto hará referencia a la página de contacto, la cual contendrá todos los medios para contactar con el curso
const Cursos = () => {
    return (
        <>
            <Header />
            <StyleSheetManager shouldForwardProp={() => true}>
                <Cabecera
                    Titulo="CONTACTO"
                    Texto_1="Si tienes dudas o quieres saber más sobre nuestros cursos online gratuitos o cómo matricularte, ponte en contacto con nosotros sin compromiso."
                    Texto_2="¡Estaremos encantados de ayudarte!"
                />
                <CuerpoContacto>
                    <ContenedorImagen>
                        <Img src={ContactoSepe} />
                    </ContenedorImagen>
                    <RedesContacto />
                </CuerpoContacto>
            </StyleSheetManager>
            <Footer />
        </>
    );
}

const CuerpoContacto = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 6%;
`

const ContenedorImagen = styled.div`
    text-align: center;
`

const Img = styled.img`
    width: 100%;
    max-width: 350px;
    margin-bottom: 5%;
`;


export default Cursos;
